import {map} from 'lodash';
import {Link, useNavigate} from 'react-router';

import Button from 'components/Button';
import KyError from 'components/Errors/KyError';
import Loading from 'components/Loading';
import {useGet} from 'helpers/KyHooks';
import {renderTechStackCell} from 'pages/public/companyTechStack/List';
import {renderCommitFreqStats} from 'pages/public/github/list/Table';


export default function MostRecentGitHubListPage() {
  const navigate = useNavigate();
  const {response, error} = useGet('api/v1/github/list', {
    searchParams: {
      offset: 0,
      limit: 3,
    },
  });

  const clickHandler = (gitHubUsername, gitHubMetaData) => navigate(`/github/profile/${gitHubUsername}`, {state: {gitHubMetaData}});
  
  let body = <Loading />;
  if (response) {
    body = (
      <div className="container mt-4 listPage mb-4">
        <h3>
          To see all GitHub users, please click <Link to="/github">here</Link>.
        </h3>
        <div className="row g-4 justify-content-center">
          {map(response.data.gitHubMetaData, (item) => {
            const {gitHubMetaDataId, gitHubUsername, languageStats, commitFreqStats} = item;
            const languages = Object.keys(languageStats);
            const sortedLanguages = languages.sort((a, b) => languageStats[b] - languageStats[a]);
            const topUsageLanguages = sortedLanguages.slice(0, 3);
            return (
              <div key={gitHubMetaDataId} className="col-sm-6 col-md-4 col-lg-4">
                <div className="card h-100 bg-light text-dark rounded-5">
                  <div className="card-body d-flex flex-column justify-content-center align-items-center text-center">
                    <h5 className="card-title fs-5 fs-sm-6">
                      <i className="bi bi-github fs-6" />{' '}
                      {gitHubUsername}
                    </h5>
                    <p className="card-text mb-1 fs-5 fs-sm-6"><strong>Popular Languages:</strong></p>
                    <ul className="list-unstyled">
                      {renderTechStackCell({value: topUsageLanguages})}
                    </ul>
                    <p className="card-text mb-1 fs-5 fs-sm-6"><strong>Commit Activity Status:</strong></p>
                    {renderCommitFreqStats({value: commitFreqStats})}
                    <div className="text-center">
                      <Button actionHandler={() => clickHandler(gitHubUsername, item)} className="btn btn-primary mt-3">View Profile</Button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <h3 className="mt-2">
          Want to share your GitHub activity and language stats with recruiters and hiring managers, please create an account <Link to="/register">here</Link>.
        </h3>
      </div>
    );
  } else if (error) {
    body = <KyError kyError={error} />;
  }
  
  return body;
}
